import React, { useState } from "react";
import { useRoutes, NavLink } from "react-router-dom";
import PrivacyHeaderImage from "../../assets/images/login/privacy-policy.png";

const BannerSection = () => {
  return (
    <>
      <section style={{ backgroundColor: "#f2f2f2" }}>
        <div className="max-container">
          <div className="padd-90">
            <div className="grid-auto-fit align-items-center max-width950">
              <div>
                <h1 className="heading39px roboto-regular mb20 text-color-131415">
                  <span className="roboto-bold">PRIVACY</span> POLICY
                </h1>

                <p className="roboto-regular heading16px mb30 text-color-131415">
                  "Our privacy policy is so strict, even Santa Claus couldn't
                  get your data from us!"
                </p>
                <NavLink
                  to={"/contact-us"}
                  className="common-btn-class main-btn-primary roboto-regular"
                >
                  Contact us
                </NavLink>
              </div>
              <div className="text-center">
                <img
                  src={PrivacyHeaderImage}
                  className="img-responsive position-relative"
                  style={{ borderRadius: "22px" }}
                  alt="Double Your Qualified Leads"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default BannerSection;
